export const ZIPPITY_COLORS = [
  '#479BA0',
  '#A8A8A8',
  '#F18487',
  '#C7C7C7',
  '#6B6B6B',
  '#1D2833',
  '#89BFC2',
  '#78848F',
  '#95292B',
  '#2E6366',
  '#E93F43',
];

// Source: https://materialui.co/colors/
export const CALENDAR_COLORS = [
  '#6D9ECA',
  '#71AA71',
  '#2E6366',
  '#2196F3',
  '#00BCD4',
  '#4CAF50',
  '#8BC34A',
  '#FFC107',
  '#FF9800',
  '#FF5722',
  '#F44336',
  '#E91E63',
  '#9C27B0',
  '#673AB7',
  '#3F51B5',
  '#7986CB',
  '#64B5F6',
  '#4FC3F7',
  '#4DD0E1',
  '#4DB6AC',
  '#81C784',
  '#AED581',
  '#FFB74D',
  '#FF8A65',
  '#E57373',
  '#F06292',
  '#BA68C8',
  '#9575CD',
  '#7986CB',
];

export const SHADES_OF_GREEN = [
  '#00cc00',
  '#00b300',
  '#009900',
  '#008000',
  '#006600',
  '#004d00',
];

export const RED = '#cc0000';

export const YELLOW = '#ffff00';

export const YELLOW_GREEN = '#bfe600';

export const getColorFromFullness = (percent) => {
  /*
    Nov 2018: Misha's requested color scale:
    https://zippitycars.slack.com/archives/C5UAP2KR9/p1541190633013300
    Red = under 50%
    Yellow = 50-75%
    Green = 75%+
  */

  if (percent < 50) {
    return RED;
  }
  if (percent < 75) {
    return YELLOW;
  }
  if (percent < 80) {
    return YELLOW_GREEN;
  }
  if (percent < 85) {
    return SHADES_OF_GREEN[0];
  }
  if (percent < 90) {
    return SHADES_OF_GREEN[1];
  }
  if (percent < 95) {
    return SHADES_OF_GREEN[2];
  }
  return SHADES_OF_GREEN[3];
};

export const getColorFromNumBookings = (num, yellow, green) => {
  if (num < yellow) {
    return RED;
  }
  if (num === yellow) {
    return YELLOW;
  }
  if (num < green) {
    return YELLOW_GREEN;
  }
  const shade = Math.min(num - green, SHADES_OF_GREEN.length - 1);
  return SHADES_OF_GREEN[shade];
};

export const getColorFromNumBookingsMechanical = (num) =>
  // 2 bookings means yellow
  // 4 bookings means green
  getColorFromNumBookings(num, 2, 4);

export const getColorFromNumBookingsDetailing = (num) =>
  // 1 booking means yellow
  // 3 bookings means green
  getColorFromNumBookings(num, 1, 3);

export const hexColorIsDark = (color) => {
  try {
    const r = parseInt(color.substring(1, 3), 16);
    const g = parseInt(color.substring(3, 5), 16);
    const b = parseInt(color.substring(5, 7), 16);
    return r + g + b < 128 * 3;
  } catch (e) {
    console.log('Could not determine whether hexColor is dark. Default: no.');
    return false;
  }
};

export const grayGradient = (percent) => {
  if (percent <= 0) {
    return '#FFFFFF';
  }
  if (percent >= 1) {
    return '#000000';
  }
  const dec = Math.round(255 * (1 - percent));
  const hex = `0${dec.toString(16)}`.substr(-2); // Pads with 0 if necessary
  return `#${hex}${hex}${hex}`;
};

export const getCompatibleTextColor = (color) =>
  hexColorIsDark(color) ? '#FFFFFF' : '#000000';

export const getGradientStyle = (percent) => {
  const bgColor = grayGradient(percent);
  const textColor = getCompatibleTextColor(bgColor);

  return {
    backgroundColor: bgColor,
    color: textColor,
  };
};

// https://css-tricks.com/snippets/javascript/lighten-darken-color/
// Because we're using hex colors for the calendar, we need to tint the buffer times them
// to make sure they contrast with the appointment blocks.
export const adjustColorBrightness = (col, amt) => {
  let usePound = false;

  if (col?.[0] == '#') {
    col = col.slice(1);
    usePound = true;
  }

  const num = parseInt(col, 16);

  let r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  let b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  let g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
};
